import React from 'react';
import './App.css';

function App() {
  const siteName = 'RSS 2 Blog Pro';
  document.title = siteName;
  return <div className="App">{siteName}</div>;
}

export default App;
